













import Vue from 'vue'
import Radio from '@/components/atoms/Radio.vue'

interface Data {
  visibility: string
}

interface Methods {}

interface Computed {}

interface Props {}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'ProfileVisibility',
  data: () => ({
    visibility: 'private'
  }),
  props: {},
  components: {
    Radio
  }
})
